var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.46967 0.53217C0.762563 0.239277 1.23744 0.239277 1.53033 0.53217L6.46972 5.47156C6.76016 5.762 7.23984 5.762 7.53028 5.47156L12.4697 0.53217C12.7626 0.239277 13.2374 0.239277 13.5303 0.53217C13.8232 0.825063 13.8232 1.29994 13.5303 1.59283L8.59094 6.53222C7.71471 7.40845 6.28529 7.40845 5.40906 6.53222L0.46967 1.59283C0.176777 1.29994 0.176777 0.825063 0.46967 0.53217Z",
    fill: "#CBCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownDisabled);
export default __webpack_public_path__ + "static/media/ArrowDownDisabled.065612df30348f634dff728eb1475980.svg";
export { ForwardRef as ReactComponent };